/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
  lang: 'de',
  homeScreen: {
    title: '',
    stayConnected: 'Folge uns',
    comingSoon: 'Demnächst verfügbar',
    downloadNow: 'Jetzt herunterladen:',
    readMore: 'Weitere Informationen ',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
    },
    programStatus: {
      title: 'Mein Status',
      loading: 'Wird geladen…',
      yourRep: 'Ihr Ansprechpartner',
      myProfile: 'Profil',
      favorites: 'Favoriten',
      registeredOn: 'Beigetreten am:',
      graduatedOn: 'Abgeschlossen am:',
      totalBadgesEarned: 'Insgesamt erhaltene Abzeichen:',
      lastBookingLogged: 'Letzte erfasste Buchung:',
      currentTier: 'Aktuelle Stufe',
      lastBadgeEarned: 'Zuletzt erhaltenes Abzeichen:',
      currentFocus: 'Aktueller Schwerpunkt:',
    },
    todaysfocus: {
      title: 'Heutiger Schwerpunkt',
      empty: 'Keine Schwerpunkte für heute',
      loading: 'Wird geladen…',
      error: 'Etwas ist schiefgelaufen',
      slideNavAria: 'Folien-Navigation',
      slideAria: 'Folie',
      carouselAria: 'Heutiger Schwerpunkt',
    },
    welcome: 'Willkommen!',
    welcomeBack: 'Willkommen zurück, {firstName}!',
    notifications: {
      loading: 'Wird geladen…',
      empty: 'Keine Benachrichtigungen',
    },
    achievements: {
      title: 'Prämien & Wettbewerbe',
      loading: 'Wird geladen…',
      lastBooking: 'Letzte Einreichung',
      currentTier: 'Aktuelle Stufe',
      contestEntries: 'Gesamtzahl der Wettbewerbsbeiträge',
      nightsBooked: 'Gebuchte Nächte',
      totalRevenue: 'Gemeldeter Gesamtumsatz',
      noBookingData: 'Keine Buchungsdaten verfügbar.',
      fileUploadSuccess: 'Die Datei wurde erfolgreich hochgeladen.',
      quickSubmit: {
        title: 'Schnelleinreichung',
        uploading: 'Wird hochgeladen…',
        clear: 'Löschen',
        submit: 'Absenden',
        submitSuccessSimulated: 'Buchung erfolgreich übermittelt',
      },
    },
  },
  profileImageView: {
    currentImage: 'Ihr aktuelles Profilbild:',
    uploadImage: 'Laden Sie Ihr Profilbild hoch:',
    chooseAFile: 'Datei auswählen…',
    cancel: 'abbrechen',
    backButton: 'Zurück',
    uploadButton: 'Profilbild hochladen',
    saveButton: 'Profilbild speichern',
    fileTooLargeTitle: 'Upload-Größe überschritten',
    fileTooLargeText: 'Maximale Bildgröße beim Hochladen ist 10 MB',
  },
  notification: {
    newAndNow: 'Neu & Aktuell!',
    alert: 'Warnung',
    message: 'Nachricht',
    badge: 'Neues Abzeichen',
    contest: 'Wettbewerb',
    'content-update': 'Inhalts-Update',
    events: 'Veranstaltungen',
    other: 'Benachrichtigung',
    welcome: 'Willkommen',
  },
  sharing: {
    email: 'E-Mail',
    download: 'Download',
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
    shareSubjectBadge: 'Abzeichen als USA-Experte',
  },
  shareSubjectDiploma: 'Auszeichnung als USA-Experte',
  loginScreen: {
    version2: {
      accountCreated: 'Ein Konto wurde erstellt, bitte prüfen Sie Ihre E-Mail, um den Vorgang abzuschließen.',
      homeTitle: 'Liegt bereits ein Profil für dich in unserem System vor?',
      homeTitleSub: 'Gib die E-Mail-Adresse ein, mit der du dich normalerweise bei Trainings-Programmen anmeldest.',
      noAccount:
        'Kein Account für ({email}) gefunden. Versuche es mit einer anderen E-Mail-Adresse oder erstelle jetzt einen neuen Account.',
      continueButton: 'Weiter',
      success:
        'Dein Account wurde erfolgreich aktualisiert. Du wirst in wenigen Sekunden zur Startseite weitergeleitet.',
      successNewAccount:
        'Zum Abschluss deiner Registrierung erhältst du eine Bestätigungs-E-Mail, um deinen Account zu verifizieren.',
      loginButton: 'Anmelden',
      matchFound: 'Wir haben ein passendes Profil gefunden. Gib dein Passwort ein, um fortzufahren.',
      magicLink: 'Anmeldung per Link in einer E-Mail:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle: 'Du erhältst per E-Mail einen Direkt-Link, über den du sofort eingeloggt wirst.',
      otherEmailButton: 'Abschicken',
      title:
        'Bitte nimm dir einen Moment Zeit für einige Angaben zu deinem persönlichen Profil und deinen Kontaktinformationen.',
      titleIndustry:
        'Bitte nimm dir einen Moment Zeit für einige Angaben zu deinem persönlichen Profil und deinen Kontaktinformationen.',
      register: 'Account erstellen',
      agent: 'Reiseberater',
      visitor: 'Branchenbesucher',
      step1: 'Schritt 1: Anwendertyp',
      step2: 'Schritt 2: Account erstellen',
      step3: 'Schritt 3: Profil erstellen',
      marketingOptIn:
        'Bist du sicher, dass du nicht mit dem Travel Trade-Team dieses Programms in Kontakt bleiben möchtest?',
      optIn: 'Ja, ich möchte in Kontakt bleiben',
      optOut: 'Kein Interesse',
      step2Sub1: 'Persönliche Angaben',
      step2Sub2: 'Angaben zu deinem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSEINSTELLUNGEN',
      privacySub:
        'Aktiviere die folgenden Kontrollkästchen, um wichtige Mitteilungen vom Travel Trade-Team zu erhalten (Produktupdates und -ankündigungen, Prämien, Incentives, FAMs usw.) und über Initiativen von TravPRO Mobile für Networking und Vertriebssupport informiert zu werden.',
      privacy:
        'Wir respektieren deine Privatsphäre und werden deine Daten weder verkaufen noch in unzulässiger Weise verwenden oder dein Vertrauen missbrauchen.',
      store: 'Lade dieses Programm aus deinem App-Store herunter:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'Wir haben einen Link zum Zurücksetzen des Passworts an deine E-Mail-Adresse geschickt. Du wirst in 10 Sekunden zur Anmeldeseite weitergeleitet.',
        emailNotExisting: 'Die eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten. Die Anmeldung wird durchgeführt.',
        magicLinkError:
          'Wir konnten deinen Account in unserer Datenbank nicht finden. Bitte melde dich manuell an. Du wirst in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten kein gültiges Token finden. Logge dich ein oder fordere einen neuen Magic Link an. Sollte das Problem weiterhin bestehen, setze dich bitte unter info@travpromobile.com mit uns in Kontakt.',
        magicLinkError2:
          'Wir konnten deinen Account in unserer Datenbank nicht finden. Bitte melde dich manuell an. Du wirst in 10 Sekunden weitergeleitet.',
        magicLinkSuccess: 'Wir haben einen Magic Link an {email} gesendet, über den du automatisch eingeloggt wirst.',
        magicLinkErrorWait: 'Bitte warte 5 Minuten, bevor du einen weiteren Magic Link anforderst.',
        emailNotFoundError:
          'Die eingegebene E-Mail-Adresse ist in unserem System nicht hinterlegt. Bitte überprüfe sie auf mögliche Tippfehler oder erstelle einen neuen Account.',
      },
      errors: {
        zipCodeNotFound: 'Die Postleitzahl wurde nicht gefunden. Bitte versuche es erneut.',
        zipCodeOnlyNumbers: 'Die Postleitzahl darf nur aus Zahlen bestehen.',
        password: 'Bitte gib ein Passwort ein.',
        passwordNotMatching: 'Die eingegebenen Passwörter stimmen nicht überein.',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen enthalten.',
        emailExists:
          'Diese E-Mail-Adresse ist bereits vorhanden oder ungültig. Bitte versuche es mit einer anderen E-Mail-Adresse oder melde dich bei deinem Account an.',
        fillInAllFields: 'Bitte fülle alle Pflichtfelder aus.',
        fillInEmail: 'Bitte gib deine E-Mail-Adresse an.',
        emailNotExisting: 'Die eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy: 'Du hast dein Passwort vergessen und möchtest es ändern? ',
        forgotSubCopy2:
          'Du möchtest ganz auf eine Passworteingabe verzichten? Wir schicken dir eine E-Mail mit einem Magic Link, über den du automatisch beim Programm angemeldet wirst. ',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Deine Rolle (bitte auswählen)',
        description: 'Was beschreibt dein Unternehmen am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort festlegen (mindestens 8 Zeichen)',
        passwordConfirm: 'Passwort bestätigen',
        firstName: 'Vorname',
        lastName: 'Nachname',
        agency: 'Name deiner Agentur',
        title: 'Deine Rolle (bitte auswählen)',
        company: 'Name des Unternehmens',
        select: 'Bitte auswählen',
        state: 'Bundesland',
        province: 'Bundesland/Kanton/Region',
        zipCode: 'PLZ',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe bist du HAUPTSÄCHLICH zugeordnet?',
        hostAgency: 'Deine Host-Agentur?',
        executive: 'Führungskraft',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        opt: 'Bleiben Sie mit dem Brand USA Team in Verbindung und erhalten Sie Updates zum USA Discovery Programm.',
        optMarketing: 'Bleiben Sie mit TravPRO in Verbindung, um über zusätzliche Lernprogramme informiert zu werden.',
        retail: 'Reisebüro',
        home: 'Reiseberater im Homeoffice',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Host-Agentur',
        call: 'Callcenter- oder webbasierte Agentur',
        other: 'Sonstiges ',
        describes: 'Was beschreibt dich und deine Agentur am besten? ',
      },
    },
    title: 'Trainings- und Sales Enablement-Programm für Tourismusprofis',
    welcome: {
      headerTop: 'Willkommen beim',
      headerBottom: 'USA Discovery Program',
    },
    sellingPoints: {
      0: 'Informationen, Marketing- und Vertriebsangebote – immer und überall',
      1: 'Multimedia-Training auf mehreren Geräten',
      2: 'Abschlusszertifikat',
      3: 'Abzeichen zu Erlebnissen und Partnerinhalten',
      4: 'Marketingmaterialien zur Weitergabe an Kunden und Interessenten',
      5: 'Jederzeit zugängliche Vertriebsressourcen',
      6: 'Trainings-Prämien',
      7: 'Incentives und MegaFams',
    },
    tAndC: {
      agree: 'Durch die weitere Nutzung erklärst du dich einverstanden mit unserer ',
      privacyPolicy: 'Datenschutzrichtlinie',
      and: ' und unseren ',
      termsConditions: 'Nutzungsbedingungen',
    },
    fields: {
      select: 'Bitte auswählen',
      country: 'Land',
      agency: 'Agentur',
      email: 'E-Mail',
      password: 'Passwort',
      passwordConfirm: 'Passwort bestätigen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      address: 'Anschrift',
      postalCode: 'PLZ',
      city: 'Stadt',
      agencyName: 'Name der Agentur',
      stateProvince: 'Bundesland/Kanton',
      required: 'Pflichtfeld',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'News und Mitteilungen Ja, ich möchte Mitteilungen von Brand USA erhalten und über aktuelle Neuigkeiten, Events, Incentives, FAMs und mehr informiert werden.',
      forgot:
        'Passwort vergessen? Klicke auf die folgende Schaltfläche, um eine E-Mail zum Zurücksetzen deines Passworts zu erhalten.',
    },
    forgot: 'Passwort zurücksetzen',
    noAgent: {
      noAgentButton: 'Ich bin kein Reiseberater',
      title: 'Vielen Dank für dein Interesse am USA Discovery Program.',
      messageWeb:
        'Der Inhalt dieser Website richtet sich ausschließlich an Tourismusexperten. \n Mehr über Brand USA erfährst du unter: ',
      messageMobile:
        'Einige Inhalte dieser App richten sich ausschließlich an Tourismusexperten. Du kannst aber eine Vorschau anzeigen, indem du auf „Weiter“ drückst.',
      continue: 'Weiter',
      visitWebsite: 'Website besuchen',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
    registered: 'Diese E-Mail wurde bereits registriert.',
  },
  welcomeScreen: {
    title: 'Willkommen beim USA Discovery Program',
    helloUser: 'Hallo {{name}},',
    hello: 'Hallo,',
    fromAgency: 'von {{agency}}',
    notUser: 'Nicht {{name}}?',
    startTraining: 'Jetzt mit dem Training beginnen',
    continueTraining: 'Training fortsetzen',
    graduated: 'Herzlichen Glückwunsch!',
    downloader: {
      stop: 'Stopp',
      init: 'Die Initialisierung läuft ...',
      lastUpdate: 'Zuletzt aktualisiert am: ',
    },
  },
  trainingScreens: {
    comingSoon: 'Demnächst verfügbar: {title}',
    categoryLockMinimum:
      'Schalte mindestens {number} Trainings-Kapitel frei, um Zugriff auf diese Kategorie zu erhalten.',
    allUnlocked: 'Du hast alle Kapitel freigeschaltet.',
    completedBase: 'Herzlichen Glückwunsch, du hast die Zertifizierung als USA-Experte geschafft.',
    certificate: 'Auszeichnung',
    chapter: 'Kapitel',
    chapterComplete: 'Das Kapitel ist abgeschlossen.',
    choose: 'Antwort auswählen',
    confirm: 'Antwort bestätigen',
    continue: 'Weiter',
    courseComplete: 'Der Kurs ist abgeschlossen.',
    durationInMinutes: '{number} Minuten',
    endReached: 'Du hast das Ende erreicht.',
    essential: 'Grundlagen',
    essentialSub:
      'Nach Abschluss des Grundlagen-Trainings erhältst du deine Zertifizierung und kannst die folgenden Spezialisierungen bearbeiten.',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
    percentageComplete: '{number} % abgeschlossen',
    restart: 'Erneut anzeigen',
    review: 'Erneut anzeigen',
    retainEnd:
      'Mithilfe der Leiste oben kannst du dich durch das Kapitel bewegen. Über die Schaltfläche „Zurück“ gelangst du zurück zur Übersicht.',
    retry: 'Erneut versuchen',
    skip: 'Zurück >',
    viewAllTitle: 'Trainings-Tipp',
    badge: 'Abzeichen herunterladen',
    viewAll:
      'Bevor du fortfährst, sieh dir bitte alle Inhalte (einschließlich der Symbole) auf dieser Seite noch einmal genau an, da sie dir zusätzliche Hilfestellung bei der Zertifizierung geben.',
    start: 'Starten',
    status: 'Aktueller Status:',
    trouble:
      'Anscheinend hast du Schwierigkeiten. Gehe den Inhalt der vorherigen Seite(n) noch einmal durch und versuche es dann erneut.',
    unlockDefault: 'Schließe das vorherige Kapitel ab, um dieses Kapitel freizuschalten.',
    unlock: 'Schließe das Trainings-Kapitel ab, um dieses Kapitel freizuschalten.',
    unlockSubtitle: 'Schließe Trainings-Kapitel ab, um weitere Kapitel freizuschalten.',
    unlockFoundation: 'Schließe das Grundlagen-Training ab, um diese Kapitel freizuschalten.',
    watchListenRead: 'Mehr ansehen, anhören und lesen',
    completed: 'Abgeschlossen',
  },
  trainingExtraScreens: {
    subtitle: 'ERLEBNISSE',
    error: 'Hoppla. Leider ist irgendwas schiefgelaufen.',
    uncompletedTitle: 'NICHT ABGESCHLOSSENE {partner} ERLEBNISSE',
    completedTitle: 'ABGESCHLOSSENE {partner} ERLEBNISSE',
    noAvailableBadges: 'Aktuell sind keine Abzeichen verfügbar.',
    interimScore: 'Bearbeite',
    interimScoreEnd: 'weitere Kapitel, um dein Abzeichen zu erhalten.',
    badgesComplete: 'Herzlichen Glückwunsch! Du hast dein Abzeichen erhalten:',
  },
  newTrainingFlow: {
    partnerModules: 'PARTNERSPEZIALISIERUNGEN',
    finishGold: 'Bearbeite diese Kapitel, um mehr über unsere Partner zu erfahren und weitere Abzeichen zu erwerben.',
  },
  points: {
    complete: {
      chapter: 'Das Kapitel ist abgeschlossen.',
      'intro-chapter': 'Das Einleitungskapitel ist abgeschlossen.',
      'sub-app': 'Die SubApp ist abgeschlossen.',
      rewards: 'Prämien abgeschlossen.',
    },
    completed: '{completed} Abzeichen erhalten',
  },
  nav: {
    home: 'Startseite',
    train: 'Training',
    learn: 'Training',
    retain: 'Retain',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Prämien',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    diploma: 'Auszeichnung',
    accountSettings: 'Account-Einstellungen',
    messages: 'Nachrichten',
    search: 'Suche',
    showcases: 'Schaukästen',
  },
  contentHeaders: {
    subapps: 'PARTNERSPEZIALISIERUNGEN',
    maintrainings: 'Orte/Regionen',
    subtrainings: 'Erlebnisse',
    itineraries: 'REISEPROGRAMME',
  },
  pageDescriptions: {
    train: 'Diese Fakten und Informationen machen dich zum Experten.',
    retain: 'Mit diesen anwenderfreundlichen Ressourcen kannst du dein Fachwissen jederzeit auffrischen.',
    promote: 'Nutze diese Materialien, um Interesse zu wecken und mit Kunden und Interessenten ins Gespräch zu kommen.',
    sell: 'Beantworte Kundenfragen und kommuniziere mit Brand USA.',
    favorites: 'Deine Lieblingsinhalte.',
    search: 'Alle Inhalte durchgehen',
    subapps: 'Bearbeite diese Kapitel, um mehr über unsere Partner zu erfahren und weitere Abzeichen zu erwerben.',
    subtrainings: 'Vertiefe dein Fachwissen und erwerbe für jeden der folgenden Abschnitte ein Abzeichen.',
    itineraries: 'Lies diese kurzen Kapitel über beliebte Roadtrips durch und verdiene dir für jedes ein Abzeichen.',
  },
  general: {
    website: 'https://www.thebrandusa.com/',
    forgot: 'Passwort vergessen?',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Zurück',
    submit: 'Abschicken',
    register: 'Registrieren',
    back: 'Zurück',
    close: 'Schließen',
    page: 'Seite',
    search: 'Suche',
    logIn: 'Anmelden',
    logOut: 'Abmelden',
    viewItem: '{Type} anzeigen',
    imageNotFound: 'Bild nicht gefunden.',
    noResultsFor: 'Keine Ergebnisse gefunden für: {{query}}',
    noFavorites: 'Du hast noch keine Favoriten.',
    noMessages: 'Du hast noch keine Nachrichten erhalten.',
    resultsFor: 'Ergebnisse für: {{query}}',
    showAll: 'Alle anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Bereits vorhanden',
    pageNotFound: '404 Seite nicht gefunden',
    oops: 'Oh oh ...',
    overview: 'Zurück zur Übersicht',
    complete: 'Weiter',
    courseComplete: 'Das Kapitel ist abgeschlossen.',
    chapterComplete: 'Das Kapitel ist abgeschlossen.',
    message: 'Nachricht ({count})',
    messagePlural: 'Nachrichten ({count})',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehe an den Reglern, um die richtige Antwort auszuwählen.',
    fitb: 'Fülle die Lücke(n) aus.',
    flip: 'Gib die korrekte Zahl an.',
    multipleChoice: 'Wähle die richtige(n) Antwort(en) aus.',
    slider: 'Wähle mithilfe des Schiebereglers die richtige Antwort aus.',
    map: 'Beantworte die Frage, indem du auf der Karte auf die richtige Stelle tippst.',
    dropdown: 'Wähle die richtige Option aus.',
    true: 'Richtig',
    false: 'Falsch',
  },
  reportCard: {
    download: 'Download',
    email: 'E-Mail',
    print: 'Drucken',
  },
  cookies: {
    consent: 'ZUSTIMMEN',
    optout: 'Nicht zustimmen',
    settings: 'Datenschutzeinstellungen',
    message:
      'Du hast uns deine Datenschutzvorlieben noch nicht mitgeteilt. Das ist nicht schlimm – wir würden dir aber gern ein bestmögliches Nutzererlebnis für den Sales Companion bieten.',
    disabled: 'Anscheinend hast du Cookies deaktiviert.',
    use: 'Für ein bestmögliches Nutzererlebnis von {{appName}} sind Cookies erforderlich.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'Informationen zur Aktivierung von Cookies findest du {{here}}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Du bist nicht angemeldet.',
    title: 'Du musst dich anmelden, um diesen Inhalt anzuzeigen.',
    guest: 'Gast',
  },
  demo: {
    message:
      'Bei dieser Website handelt es sich um eine Demoversion des endgültigen Produkts. Sie befindet sich in der Entwicklungsphase und ist noch nicht fertiggestellt.',
    consent: 'Verstanden',
  },
  share: {
    header: 'Teile diese Ressource über deine liebsten Social Media-Netzwerke.',
    download: 'Download',
    email: 'E-Mail',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  storeButtons: {
    title: 'Hole dir die App für dein Mobilgerät.',
  },
  onMobile: {
    header: 'Anscheinend versuchst du, auf einem Mobilgerät auf die {appName} App zuzugreifen.',
    body: 'Du kannst dir das Programm ganz einfach herunterladen. Besuche deinen App-Store und suche nach {appName}. Oder klicke auf eine der folgenden Schaltflächen.',
    benefits: {
      1: 'Informationen, Marketing- und Vertriebsangebote – immer und überall',
      2: 'Multimedia-Training auf mehreren Geräten',
      3: 'Abschlusszertifikat',
      4: 'Abzeichen zu Erlebnissen und Partnerinhalten',
      5: 'Marketingmaterialien zur Weitergabe an Kunden und Interessenten',
      6: 'Jederzeit zugängliche Vertriebsressourcen',
      7: 'Trainings-Prämien',
      header: 'Inhalt und Vorteile des Programms:',
    },
  },
  custom: {
    splitUsers: 'Ich bin ein ...',
    brandAmbassador: 'Markenbotschafter',
    travelPro: 'Tourismusexperte',
  },
  rewards: {
    menu: {
      home: 'Belohnungen\nStartseite',
      achievements: 'Schulung\nErfolge',
      bookings: 'Abzeichen\nAnreize',
      form: 'Buchungen\nEinreichen',
    },
    rewards: 'Prämien',
    title: 'Willkommen im Rewards & Achievements Center',
    subheader: 'Hier kannst du deine Trainings-Erfolge im Auge behalten und teilen.',
    button: 'Buchung einreichen',
    viewAllBookings: 'Buchungen',
    viewDashboard: 'Punkte-Dashboard',
    viewRewards: 'Überblick',
    overview: {
      valid: '* Die eingereichten Buchungen sind erst nach Abschluss der Kundenreise gültig.',
    },
    home: {
      entries: 'Aktuelle Einträge',
      trainingAchievements: 'TRAININGS-ERFOLGE',
      trainingAchievementsText:
        'Behalte deinen Übungsfortschritt, deine Zertifizierungen und deinen Status im Blick. Außerdem kannst du hier deine Auszeichnung als USA-Experte sowie alle erworbenen Abzeichen für Erlebnisse und Partnerspezialisierungen herunterladen und teilen.',
      bookingContests: 'INCENTIVES-DASHBOARD',
      bookingContestsText:
        'Über das Incentives-Dashboard lassen sich aktuelle Incentive-Programme bequem verfolgen und verwalten. ',
      submitBooking: 'BUCHUNGEN EINREICHEN',
      submitBookingText: 'Hier reichst du Buchungen ein, die du auf Buchungs-Incentives anrechnen lassen willst.',
      currentContest: 'AKTUELLE INCENTIVES',
      noContests: 'Aktuell gibt es keine Incentives für Abzeichen.',
      ContestEndDate: 'Die Incentive endet am:',
      ContestDetails: 'Details zur Incentive',
      ContestSeeProgram: 'Weitere Details findest du in den',
      ContestTerms: 'Nutzungsbedingungen',
      ContestForDetails: 'des Programms.',
      ContestPartnerLink: 'Zum Partner',
      ContestLink: 'Zum Link',
    },
    bookingsView: {
      title: 'Buchungen',
      infoMessage:
        'Sortieren Sie mit den Schaltflächen oben und klicken Sie auf einen beliebigen Datensatz, um die Anmeldedetails zu verwalten. Alle ausstehenden Einträge werden innerhalb von 72 Stunden überprüft.',
    },
    leaderboardScreen: {
      prizes: 'Preise',
      tAndC: 'Es gelten die Geschäftsbedingungen.*',
    },
    dashboardView: {
      title: 'Incentives-Dashboard',
      subtitle: 'Verfolge alle deine Aktivitäten zu Incentives.',
      badge: 'Incentives für Abzeichen',
      activity: 'Incentives für Buchungen',
      manage: 'Buchungen verwalten',
      manageSub:
        'Verfolgen Sie unten die aktuellen Buchungen, oder sehen Sie sich die archivierten Buchungen an, indem Sie das Dropdown-Menü verwenden.',
      noBadgeIncentives: 'Aktuell gibt es keine Incentives für Abzeichen.',
      noBookings: 'Es liegen keine Daten vor.',
      state: {
        approvedEntries: 'Genehmigte Einträge',
        pendingEntries: 'Ausstehende Einträge',
        declinedEntries: 'Abgelehnte Einträge',
        viewAll: 'Alle Anzeigen',
      },
      currentYear: 'Laufendes Jahr',
      archivedBookings: 'Archivierte Buchungen',
    },
    bookingForm: {
      title: 'Formular für Gutschriften zu Reisebuchungen für die USA',
      subTitle: 'Buchung eingeben:',
      required: 'Mit * markierte Felder sind Pflichtfelder',
      email: 'E-Mail des Beraters',
      agentFirstName: 'Vorname des Beraters',
      agentLastName: 'Nachname des Beraters',
      company: 'Name der Agentur / des Unternehmens',
      iata: 'IATA/CLIA-Nr.',
      stateProvince: 'Bundesland/Kanton',
      postalCode: 'PLZ',
      country: 'Land',
      city: 'Stadt',
      birthday: 'Geburtsdatum',
      type: 'Typ der Gästereise',
      source: 'Buchungsquelle',
      tourOperator: 'Touranbieter',
      firstName: 'Vorname des Gasts',
      lastName: 'Nachname des Gasts',
      confirmNumber: 'Buchungsreferenz/PNR-Nummer',
      ticketNumber: 'Ticketnummer',
      file: 'RezSnap™-Beleg ',
      arrivalDate: 'Anreisedatum Unterkunft',
      departureDate: 'Abreisedatum Unterkunft',
      brand: 'Gebuchte Marke',
      lengthOfStay: 'Aufenthaltsdauer',
      cost: 'Gesamtkosten der Buchung',
      rooms: 'Anzahl Zimmer',
      airline: 'Fluggesellschaft (2-stelliger Code)',
      gateway: 'Startort (3-stelliger Flughafencode)',
      destination: 'Zielort/Insel (3-stelliger Flughafencode)',
      disclaimer: '* Pflichtfelder',
      button: 'Buchung einreichen',
      sub: 'Deine Angaben',
      sub2: 'Informationen zur Buchung',
      travelDepartureDate: 'Datum der Abreise',
      travelReturnDate: 'Datum der Rückkehr',
      flightNumber: 'Flugnummer des Flugs in die USA',
      numberOfTravelers: 'Anzahl Reiseteilnehmer',
      edit: 'Angaben bearbeiten',
      fileUploaded: 'Die Datei wurde erfolgreich hochgeladen.',
      select: 'Bitte Option auswählen',
      drag: 'Ziehen Sie eine Datei hierher, oder klicken Sie, um eine Datei auszuwählen.',
      fileType: '(Eine Datei, .jpeg, .png und .pdf Dateien werden akzeptiert. Die maximale Dateigröße beträgt 100 MB.)',
      maxSize: 'Die maximale Dateigröße beträgt 100 MB.',
    },
    TermsAndConditions: {
      title: 'Nutzungsbedingungen',
      subTitle: 'Quartalsprämien für USA-Experten',
      body1:
        'Jeder eingereichten Buchung muss ein Nachweis über den vollständig beglichenen Preis der Buchung beigelegt werden. Bei der Auswahl der Prämienempfänger werden nur Buchungen berücksichtigt, zu denen ein verifizierter Nachweis vorliegt. Die eingereichten Buchungen müssen alle Regeln des USA Discovery Program erfüllen.',
      body2:
        'Teilnahmeberechtigt sind Personen mit Wohnsitz in den USA oder Brand USA. Die betreffenden Personen müssen das im Bundesstaat, in der Provinz oder im Territorium ihres Wohnsitzes geltende Alter für Volljährigkeit erreicht haben. Mitarbeiter von Touranbietern sind NICHT zur Teilnahme an Verlosungen berechtigt und werden bei der Vergabe von zusätzlichen Preisen NICHT berücksichtigt. Personen mit Wohnsitz in der Provinz Quebec sind NICHT zur Teilnahme an Verlosungen berechtigt und werden bei der Vergabe von zusätzlichen Preisen NICHT berücksichtigt.',
      body3:
        'Für den Erhalt von Prämien muss eventuell ein Nachweis über die Zulassung als Reiseberater (in einem Reisebüro / im Homeoffice) vorgelegt werden. Die angebotenen Prämien können im Verlauf des Programms geändert werden.',
      body4: 'Datenschutz und Verwendung personenbezogener Informationen',
      body5:
        'Teilnehmende Reiseberater (i) gewähren dem Aussteller der Prämien das Recht, ihren Namen sowie die Angaben zu Stadt, Bundesland/Kanton, Postleitzahl, Bestätigung zum Status der Volljährigkeit, Telefonnummer und E-Mail-Adresse auch, aber nicht nur, dafür zu verwenden, die Prämienempfänger zu verständigen und bekannt zu geben und die Preise zu übermitteln; (ii) gewähren Prämienempfängern das Recht, ihre personenbezogenen Angaben ohne weitere Vergütung für PR- und Werbezwecke in Verbindung mit den Prämien in allen derzeit bekannten oder künftig verbreiteten Medien zu verwenden, sofern dies nicht gesetzlich untersagt ist; und (iii) erkennen an, dass die Prämienempfänger ihre personenbezogenen Angaben in Verbindung mit den unter (i) und (ii) oben aufgeführten Aktivitäten gegenüber dritten Vertretern und Service-Providern offenlegen.',
      button: 'Zurück zur Landing-Seite',
    },
    thankYouPage: {
      thanks: 'Vielen Dank',
      congrats: 'Glückwunsch, ',
      body: 'deine Buchung ist eingegangen und wurde zur Verifizierung an die für die Kampagnenaufsicht zuständige Stelle weitergeleitet.',
      link: 'Um als Gewinner infrage zu kommen, musst du das Grundlagen-Training aus dem USA Discovery Program absolviert haben.',
    },
  },
  facts: {
    title: 'Wussten Sie schon?',
  },
  badgeView: {
    other: 'Regionale Partner',
    unlock: 'Beginnen Sie mit dem Absolvieren von Schulungselementen, um Abzeichen zu erhalten',
    title: 'Schulungserfolge',
    subtitle:
      'Willkommen in Ihrem Erfolgs-Dashboard, wo Sie Ihre Diplome und Spezialisierungsabzeichen anzeigen, verfolgen und herunterladen können.',
    viewBadge: 'Status anzeigen',
    badgeDisplayTitle: 'STATUS DER METALLISCHEN BELOHNUNGEN',
    badgeAchievement:
      'Sie haben den Status {rank} erreicht! Klicken Sie auf das Symbol rechts, um Ihren Status anzuzeigen und zu teilen.',
    badgesCompleteTitle: 'Ihre Spezialisierungsabzeichen',
    badgesCompleteSubtitle: 'Klicken Sie auf die Symbole, um Ihre Abzeichen anzusehen, zu speichern und zu teilen.',
    badgesIncompleteSubtitle: 'Erhalten Sie mehr Abzeichen, indem Sie diese Kapitel abschließen.',
    bronze: 'Bronze',
    silver: 'Silber',
    gold: 'Gold',
    platinum: 'Platin',
    diploma: 'Diplom',
    experiencesBadgesSectionTitle: 'Die Experience-Abzeichen',
    itinerariesBadgesSectionTitle: 'Routen-Abzeichen',
    partnerSpecializationBadgesSectionTitle: 'Partner-Spezialisierungs-Abzeichen',
    complete: 'VOLLSTÄNDIG',
  },
  missing: {
    discover: 'Entdecken',
    pacific: 'Pazifik',
    west: 'Westen',
    southwest: 'Südwesten',
    midwest: 'Mittlerer Westen',
    south: 'Südosten',
    northeast: 'Nordosten',
    territories: 'Territorien',
    shoppingAttractions: 'Einkaufen & Attraktionen',
    gettingAround: 'Fortbewegung',
    regionalPartners: 'Regionale Partner',
    greatOutdoors: 'Große Natur',
    winterSports: 'Wintersport',
    coastalEscapes: 'Küstenfluchten',
    flyDrive: 'Flug-Fahrt',
    foodDrink: 'Essen & Trinken',
    luxury: 'Luxus',
    musicCultureHeritage: 'Musik, Kultur & Erbe',
    nationalParks: 'Nationalparks',
    regionMap: 'Regionskarte',
    videos: 'Videos',
    images: 'Bilder',
    incentives: 'Incentive',
    southeast: 'Südosten',
  },
  searchModal: {
    search: 'Suchen',
    subtitle: 'Alle Inhalte durchsuchen',
    pages: 'USA Discovery Program',
    partnerPages: 'Partner-Programme',
    salesCompanion: 'Sales Companion Artikel',
    exhibitionTiles: 'Partner-Showcases',
    noResults: 'Keine Ergebnisse gefunden...',
  },
};
